module.exports = __webpack_public_path__ + "img/featuredartist (7).398d1511.jpg";